
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutSqPy0mlVh5sT8_smFN7I6yG4efJH_45ecv2lJyx6EqcpIMeta } from "/Users/nrick/workSpace/hakko-official-site/pages/about.vue?macro=true";
import { default as index3PqvNk5b_45LzSz2zGTkw5ADFUYlKtODQb_3TyxGr5iAYMeta } from "/Users/nrick/workSpace/hakko-official-site/pages/index.vue?macro=true";
import { default as _91id_933Px_eghCZkzkQvJESHB7VpOt6kgbPiRb_Y1nOxjSPhEMeta } from "/Users/nrick/workSpace/hakko-official-site/pages/news-detail/[id].vue?macro=true";
import { default as newstzdPOplXA_45UQGcwzDt7NEDMGgR0vdcJUqdaY67ZCYuYMeta } from "/Users/nrick/workSpace/hakko-official-site/pages/news.vue?macro=true";
export default [
  {
    name: "about___ja",
    path: "/about",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/about.vue")
  },
  {
    name: "about___hant",
    path: "/hant/about",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/about.vue")
  },
  {
    name: "index___ja",
    path: "/",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/index.vue")
  },
  {
    name: "index___hant",
    path: "/hant",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/index.vue")
  },
  {
    name: "news-detail-id___ja",
    path: "/news-detail/:id()",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news-detail/[id].vue")
  },
  {
    name: "news-detail-id___en",
    path: "/en/news-detail/:id()",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news-detail/[id].vue")
  },
  {
    name: "news-detail-id___hant",
    path: "/hant/news-detail/:id()",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news-detail/[id].vue")
  },
  {
    name: "news___ja",
    path: "/news",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news.vue")
  },
  {
    name: "news___hant",
    path: "/hant/news",
    component: () => import("/Users/nrick/workSpace/hakko-official-site/pages/news.vue")
  }
]